import React from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import Mailto from 'react-mailto';
import { Watch } from 'scrollmonitor-react';

import { textContainer, shadowless } from '../styles';
import Animated from '../components/Animated';

const CV = () => (
  <div {...textContainer}>
    <Helmet title="CV of lucastswick" description="lucastswick CV" />
    <Animated as="h1">CV</Animated>
    <Animated as="h2">Lucas Swick</Animated>
    <Animated>
      b. 1979, Edmonton, Alberta
      <br />
      Lives and works in Portland, Oregon
      <br />
      As a Generative Artist, Lucas uses math to capture and celebrate the
      beauty of nature.
      <br />
      As a Software Engineer, Lucas relies on 20+ years experience to create
      bespoke digital experiences and tools for the web.
    </Animated>
    <Animated>
      <Mailto
        email="lucas@generativeartist.com"
        obfuscate={true}
        {...shadowless}
        target="_blank"
      >
        Email me
      </Mailto>
      {' | '}
      <Link {...shadowless} to={'/'}>
        generativeartist.com
      </Link>
      <br />
      <a
        {...shadowless}
        target="_blank"
        rel="nofollow noopener noreferrer"
        href="https://twitter.com/lucastswick"
      >
        Twitter
      </a>
      {' | '}
      <a
        {...shadowless}
        target="_blank"
        rel="nofollow noopener noreferrer"
        href="https://instagram.com/lucastswick"
      >
        Instagram
      </a>
    </Animated>
    <Animated as="h2">Employment</Animated>
    <Animated>
      <strong>2022</strong> Co-founded{' '}
      <a
        href="https://fdk.frahm.art/editor"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        Frahm
      </a>
      , generative frames for your digital art
      <br />
      <strong>2021</strong> Sold over 100 Eth of NFTs over{' '}
      <a
        href="https://opensea.io/collection/blom-by-lucastswick"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        multiple
      </a>{' '}
      <a
        href="https://opensea.io/collection/lucastswick-form-decay"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        generative art
      </a>{' '}
      <a
        href="https://foundation.app/collection/solastalgia"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        drops
      </a>
      <br />
      <strong>2018-2021</strong> Nike, Technical Director
      <br />
      <strong>2018</strong>{' '}
      <a
        href="/work/community-gardens-a-data-driven-generative-art-installation-about-housing-insecurity-at-ncsu"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        Community Gardens
      </a>
      , a data-driven generative art installation at NCSU
      <br />
      <strong>2015-2018</strong>{' '}
      <a
        href="https://weareparliament.com/"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        Parliament
      </a>
      , Technical Director
      <br />
      <strong>2017</strong>{' '}
      <a
        href="/work/lightblades-installation-at-the-geode-in-portland"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        Lightblades
      </a>
      , a 3-story tall generative art public art installation at the Geode,
      Portland OR
      <br />
      <strong>2016</strong>{' '}
      <a
        href="http://localhost:3000/work/generative-art-installation-in-union-square"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        6k art installation
      </a>{' '}
      for Capital One at Union Square, NY
      <br />
      <strong>2015</strong> Blom Generative Art print series, self-published
      <br />
      <strong>2010-2015</strong>{' '}
      <a
        href="https://whoisowenjones.com/"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        Owen Jones & Partners
      </a>
      , Senior Software Engineer
    </Animated>
    <Animated as="h2">Group Exhibitions</Animated>
    <Animated>
      <strong>2016</strong> Byte-me 5.0, AFRU, Portland OR
      <br />
      <strong>2015</strong> C.A.R.D.S 1.0 Release Party, Instrument, Portland OR
      <br />
      <strong>2014</strong> Uncontext, Diode, Portland OR
    </Animated>
    <Animated as="h2">Collections</Animated>
    <Animated>
      <strong>Private Collection</strong> Portland OR
      <br />
      <strong>Private Collection</strong> San Francisco, CA
      <br />
      <strong>Private Collection</strong> Washington, DC
    </Animated>
  </div>
);

export default Watch(CV);



// WEBPACK FOOTER //
// ./src/pages/CV.js